export enum BulkBarcodeJobStatus {
  Created = 1,
  InProcess = 2,
  Processed = 3,
}
